import { createSlice } from '@reduxjs/toolkit';
import { IInvoicesListState } from './types';
import { fetchInvoices } from './invoicesList.thunks';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { BlockedByFeature } from '../../../featureToggles/features/utils';

export const initialState: IInvoicesListState = {
  invoices: [],
  totalCount: 0,
  loading: false,
  nextPage: undefined
};

const invoicesListSlices = createSlice({
  name: 'invoicesList',
  initialState,
  reducers: {
    // TODO TBD
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvoices.pending, (state) => {
      if(!isFeatureEnabled(Features.PlgExternal)) {
        console.info(`fetchInvoices.pending. ${BlockedByFeature}`);
        return;
      }
      state.loading = true;
      state.invoices = initialState.invoices;
      state.totalCount = initialState.totalCount;
    });
    builder.addCase(fetchInvoices.fulfilled, (state, action) => {
      if(!isFeatureEnabled(Features.PlgExternal)) {
        console.info(`fetchInvoices.fulfilled. ${BlockedByFeature}`);
        return;
      }
      state.loading = false;
      state.invoices = [
        ...action.payload.invoices || []
      ];
      state.totalCount = action.payload.invoices.length;
      if(isFeatureEnabled(Features.PlgExternal3)) {
        state.nextPage = action.payload.nextPage;
      }
    });
    builder.addCase(fetchInvoices.rejected, (state) => {
      if(!isFeatureEnabled(Features.PlgExternal)) {
        console.info(`fetchInvoices.rejected. ${BlockedByFeature}`);
        return;
      }
      state.loading = false;
    });
  }
});

export const invoicesListReducer = invoicesListSlices.reducer;
